export type CalculatorKey = "leads" | "pct" | "value";

export type CalculatorField = {
  key: CalculatorKey;
  label: string;
  min: number;
  max: number;
  step: number;
  defaultValue: number;
  prefix?: string;
  suffix?: string;
};

export const calculatorFields: CalculatorField[] = [
  { key: "leads", label: "Leads que recibes al mes", min: 10, max: 500, step: 1, defaultValue: 50 },
  {
    key: "pct",
    label: "% de leads que no reciben respuesta rápida",
    min: 0,
    max: 100,
    step: 1,
    defaultValue: 30,
    suffix: "%",
  },
  {
    key: "value",
    label: "Valor promedio de un cliente ($)",
    min: 50,
    max: 10000,
    step: 50,
    defaultValue: 500,
    prefix: "$",
  },
];
